// src/pages/private/settings/securityTabs/SecurityModal.jsx

import React, { useState } from 'react';
import Modal from 'react-modal';

function ErrorMessage({ message }) {
  if (message) {
    return <p className="message-error">{message}</p>;
  } else {
    return <div className="error-spacer"></div>;
  }
}

function SecurityModal({
  isModalOpen,
  handleOverlayClick,
  qrCode,
  secretCode,
  copyToClipboard,
  globalError,
  mfaAppCode,
  setMfaAppCode,
  mfaMailCode,
  setMfaMailCode,
  sendMfaMail,
  verifyMfaEmailCode,
  verifyAppMFA,
  mfaError,
  setIsModalOpen
}) {
  const [selectedOption, setSelectedOption] = useState('authenticator');

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={() => setIsModalOpen(false)}
      contentLabel="MFA Setup"
      className="mfa-modal"
      overlayClassName="modal-overlay"
      onClick={handleOverlayClick}
    >
      <div className="modal-content">
        <h3 className="mfa-h3">Two-Step Authentication</h3>
        <div className="mfa-radio-buttons">
          <label>
            <input
              type="radio"
              value="authenticator"
              checked={selectedOption === 'authenticator'}
              onChange={() => setSelectedOption('authenticator')}
            />
            Authenticator 2FA
          </label>
          <label>
            <input
              type="radio"
              value="email"
              checked={selectedOption === 'email'}
              onChange={() => setSelectedOption('email')}
            />
            Email 2FA
          </label>
        </div>

        {selectedOption === 'authenticator' && (
          <>
          <div className='modal-content-type'>
            <div className="modal-left">
              <img src={qrCode} alt="QR Code" className='mfa-qr-code'/>
              <div className='mfa-code-number'>
                <span className='mfa-secret-label'>Authenticator Code:</span>
                <span className='mfa-secret-code'> {secretCode}</span>
                <button className='mfa-copy-code' onClick={copyToClipboard}>Copy the Authenticator code</button>
              </div>
              <ErrorMessage message={globalError} />
              <input
                className='mfa-code-field'
                type="text"
                placeholder="______"
                value={mfaAppCode}
                onChange={(e) => setMfaAppCode(e.target.value)}
              />
              <button className="btn-style1 mfa-red" onClick={verifyAppMFA}>Check Code</button>
              <ErrorMessage message={mfaError} />
            </div>

            <div className="modal-right">
            <div className="mfa-bullet-points">
                <ol>
                    <li>Please make sure that your smartphone's time is set to automatic.</li>
                    <li>Install an Authenticator app on your smartphone (Authy, Google authenticator, Aegis Authenticator).</li>
                    <li className="desktop">Scan the QR-Code.</li>
                    <li className="mobile">Copy the code and paste it into your authenticator.</li>
                    <li>Enter the generated code into the field below the QR-Code.</li>
                </ol>
            </div>
            </div>
          </div>

          </>
        )}

        {selectedOption === 'email' && (
        <div className='modal-content-type'>
          <div className="modal-left" >
           
          <button className="btn-style1 mfa" onClick={sendMfaMail}>Send me the code</button>
            <ErrorMessage message={globalError} />
            <input
              className='mfa-code-field'
              type="text"
              placeholder="______"
              value={mfaMailCode}
              onChange={(e) => setMfaMailCode(e.target.value)}
            />
            <button className="btn-style1 mfa-red" onClick={verifyMfaEmailCode}>Check Code</button>
            <ErrorMessage message={mfaError} />
          </div>

          <div className="modal-right">
            <div className="mfa-bullet-points">
                <ol>
                <li>Click on the button to receive the activation code.</li>
                <li>Check your email to retrieve the activation code.</li>
                <li>Enter the generated code into the activation field </li>
                <li>Click on the CHECK CODE button"</li>
              </ol>
            </div>
          </div>
        </div>
        )}
      </div>
    </Modal>
  );
}

export default SecurityModal;
